import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=6b052b9d&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b052b9d')) {
      api.createRecord('6b052b9d', component.options)
    } else {
      api.reload('6b052b9d', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=6b052b9d&", function () {
      api.rerender('6b052b9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/Layout.vue"
export default component.exports